import { withRouter } from 'react-router-dom';
import RevertChangeCta from './RevertChangeCta';

export default withRouter(RevertChangeCta);
